import Base from "../Step.es6";

// Upload users image
export default class extends Base {
    constructor(Configurator) {
        super('upload', Configurator.mode.DESIGN_USER, Configurator);
        this.level          = Configurator.PURCHASE_LEVEL_MEDIUM;
        this.stopOnSubmit   = false;
        this.values         = {
            image:   App.Utilities.String.EMPTY_STRING,
        }
    }
    get url() { return 'upload' }

    validate() {
        return this.hasImage();
    }
    commit(values) {
        this.values.image   = values.uuid;
        this.ready          = true;
        return this;
    }
    remove() {
        const Configurator = this.Configurator;
        this.values.image = App.Utilities.String.EMPTY_STRING;
        Configurator.Progress.get('edit').remove();
        Configurator.Design.setId(Configurator.id);
        Configurator.Design.Tin.update();
        return this;
    }
    run() {
        this.Configurator.Preview.prepareTin();
        return this;
    }
    hasImage() {
        return this.values.image !== App.Utilities.String.EMPTY_STRING;
    }
}
